import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button, Checkbox } from 'antd'
import { PoweroffOutlined } from '@ant-design/icons'
import { langChange } from '../../reducers/langReducers'
import './header.less'

export default function Header() {
    let history = useHistory();
    const dispatch = useDispatch()
    let env = sessionStorage.getItem('env');
    // console.log('env:', env);
    const langValue = useSelector(state => state.langList.value)
    let logout = () => {
        // console.log("===>logout");
        sessionStorage.clear();
        SetLogin(false);
    }

    const [login, SetLogin] = useState(true);
    useEffect(() => {
        if (!login) {
            // console.log("退回到登录页面");
            history.push('/login');
        }
    }, [login])

    let btnStyle = {
        'backgroundColor': '#ebeeff',
        // 'width': '200px',
        'height': '48px',
        'borderRadius': '9px',
        'fontFamily': 'Segoe UI',
        'fontSize': '18px',
        'lineHeight': '24px',
        'letterSpacing': '0px',
        'color': '#526be8',
    }
    let uname = sessionStorage.getItem('uname');
    let roleName = sessionStorage.getItem('roleName');
    var en_rolename = sessionStorage.getItem('en_role_name')
    let useTips = `${uname}-` + (langValue == 0 ? `${roleName} ${en_rolename}` : (langValue == 1 ? roleName : en_rolename));
    // 切换语言组件
    // -- 监听变化
    const langChangeHandle = (value) => {
        var n = 0
        if (value.length > 1) {
            n = 0
        } else {
            if (value[0] == '中文') {
                n = 1
            } else {
                n = 2
            }
        }
        sessionStorage.setItem('langValue', n)
        dispatch(langChange({ value: n }))
    }

    const langOptions = ['中文', 'English'];
    return (
        <div id='webpage-header' className='webpage-header'>
            <div className='header-left'>
                <div className="logo"  >
                    <img src="./images/logo.png" />
                </div>

                <div className="logo-title" >
                    <div className='lgline'>慈济捐款系统</div>
                    <div className='lgline_sub'>Tzuchi Donation System</div>

                </div>
                {env && env.includes('test') ?
                    <div><span style={{ color: 'red', fontSize: 24 }}>（测试环境）</span></div>
                    : ''
                }

                <div className='lang-box'>
                    语言 Language：
                    <Checkbox.Group options={langOptions} defaultValue={langOptions} onChange={langChangeHandle}></Checkbox.Group>
                </div>
            </div>

            <div className="user-bar">
                <h1 style={{ fontSize: '18px', color: 'rgb(82, 107, 232)', paddingRight: '1rem' }}>{useTips} </h1>
                <Button onClick={logout} style={btnStyle}
                    icon={<PoweroffOutlined />}>登出/logout</Button>
            </div>
        </div>
    )
}
